import script from "./PageToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PageToolbar.vue?vue&type=script&setup=true&lang=js"

import "./PageToolbar.vue?vue&type=style&index=0&id=1f619eb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f619eb3"]])

export default __exports__